// tslint:disable-next-line:no-submodule-imports
import uuid from 'uuid/v4';
// tslint:disable-next-line:no-any
export class Layer {
    constructor(_render, state, contentOptions, options, removeFromState, triggerUpdate) {
        this._render = _render;
        this.state = state;
        this.contentOptions = contentOptions;
        this.options = options;
        this.removeFromState = removeFromState;
        this.triggerUpdate = triggerUpdate;
        this.closed = false;
        this.handle = {
            close: () => this.close(),
            update: (newState) => {
                this.state = newState;
                this.triggerUpdate();
            },
            isClosed: () => this.closed
        };
        this.id = `${this.options.id || 'layer'}-${uuid()}`;
        this.close = this.close.bind(this);
        this.render = this.render.bind(this);
    }
    get isClosed() {
        return this.closed;
    }
    close(result) {
        if (this.closed) {
            return;
        }
        const wasCloseable = this.removeFromState(this);
        if (!wasCloseable) {
            // TODO notify parent that it does not exist anymore?
            return;
        }
        this.closed = true;
        if (this.options.onClose) {
            try {
                this.options.onClose(this.state, result, this.contentOptions);
            }
            catch (error) {
                console.error('A layer close callback threw an error:', error);
            }
        }
        this.triggerUpdate();
    }
    render() {
        return this._render(this.state, this.close, Object.assign(Object.assign({}, this.contentOptions), { id: this.id }));
    }
}
//# sourceMappingURL=layer.js.map